@if (showSplash()) {
  <div
    class="bg-white fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center w-full h-full z-[100] opacity-100"
    [ngStyle]="{
      left: windowWidth(),
      opacity: opacityChange(),
      transition: splashTransition()
    }"
  >
    <div class="flex flex-col justify-center items-center">
      <div class="bg-[url('/assets/icons/icon-512x512.png')] bg-no-repeat max-w-full bg-center bg-contain w-[30em] h-[30em]"></div>
      <div class="mt-8 text-black font-extrabold text-[2.5em] tracking-[4px]">PujasWeb</div>
      <div class="bg-[url('/assets/three-dots.svg')] bg-no-repeat max-w-full bg-center bg-contain w-20 h-20 mt-[50px]"></div>
    </div>
  </div>
}